export const ADMIN = 'bwycadmin'
export const BACKEND = 'backend'
export const STANDARD = 'bwycstand'
export const BMWSTANDARD = 'bmwstand'
export const HOTKEY = 'bwychotkey'
export const USER = 'user'

export const ROLE_OPTIONS = []